import { version as uuidVersion } from 'uuid';
import { validate as uuidValidate } from 'uuid';
import { MaybeString } from 'src/common/types';
import { isString } from 'src/utils/typeguards/isString';

export const isUUID = (identifier: MaybeString): boolean =>
    isString(identifier) && uuidValidate(identifier) && uuidVersion(identifier) === 4;
